import { render, staticRenderFns } from "./RegularizationReview.vue?vue&type=template&id=aa907e08&"
import script from "./RegularizationReview.vue?vue&type=script&lang=ts&"
export * from "./RegularizationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RegularizationReview.vue"
export default component.exports